import request from '@/utils/request'

// 退货单列表
export function fetchList(data) {
	return request({
		url: '/oms/userOrder/return/queryReturnOrderList',
		method: 'POST',
		data
	})
}

// 退货审核
export function checkOrderReturn(data) {
	return request({
		url: '/oms/userOrder/return/checkOrderReturn',
		method: 'POST',
		data
	})
}

// 填写退回快递单号
export function uploadReturnShippingNo(data) {
	return request({
		url: '/oms/userOrder/return/uploadReturnShippingNo',
		method: 'POST',
		data
	})
}

// 退货商品明细
export function queryReturnInfo(params) {
	return request({
		url: '/oms/userOrder/return/queryReturnInfo',
		method: 'GET',
		params
	})
}



// WEBPACK FOOTER //
// ./src/api/oms/return-order.js